import { skipToken } from '@reduxjs/toolkit/dist/query'

import { auth } from 'config/firebase/firebase.config'

import { useFetchUserQuery } from 'state/slices/api'

export const useUser = () => useFetchUserQuery(auth.currentUser?.uid ?? skipToken)
